// extracted by mini-css-extract-plugin
export default {"cookieBanner":"L90cpr1pKweH0eROOPB6a","privacyLink":"_13Y3Vn2cKOhYWzmrop4DFz","acceptButton":"_19snVCWmyCO90owXYc_mMT"};